import { useMemo } from 'react';
import { Select } from 'ui/selectv2/Select';
import type { CombinedRole } from '../types';

type RolesDropdownProps = {
  isDisabled?: boolean;
  onChange: (value: CombinedRole['name'], combinedRoles: CombinedRole[]) => void;
  roles: CombinedRole[];
  value: CombinedRole['name'];
};

export const RolesDropdown = ({ isDisabled, onChange, roles, value }: RolesDropdownProps) => {
  const opts = useMemo(
    () => roles.map((role) => ({ value: role.name, label: role.name })),
    [roles],
  );
  const val = opts.find((role) => role.label === value);

  return (
    <div data-test="rolesDropdown">
      <Select
        isDisabled={isDisabled}
        value={[val]}
        options={opts}
        placeholder="Select a role..."
        onSelect={([newValue]) => onChange(newValue.value, roles)}
      />
    </div>
  );
};
